import { defineComponent as v, ref as s, computed as u, onBeforeMount as b, openBlock as r, createElementBlock as B, normalizeClass as $, normalizeStyle as g, withModifiers as d, createBlock as N, createCommentVNode as z, renderSlot as m, createVNode as C } from "vue";
import L from "../BaseIcon.js";
import M from "../StaticSpinner.js";
const H = ["id", "data-cy", "type", "data-active", "disabled", "aria-labelledby"], E = /* @__PURE__ */ v({
  __name: "BaseButton",
  props: {
    lazyLoadIcon: { type: Boolean, default: !0 },
    btnClass: { default: "uikit-btn-w-primary" },
    outlined: { type: Boolean, default: !1 },
    size: { default: "" },
    iconName: { default: "" },
    iconNameHovering: { default: "" },
    iconClass: { default: "uikit-mr-[5px]" },
    isEmpty: { type: Boolean, default: !1 },
    keepActive: { type: Boolean, default: !1 },
    isLoading: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["mouseover", "mouseout", "click"],
  setup(f) {
    const o = f, i = s(!1), n = s(""), p = u(() => o.size ? `uikit-btn-${o.size}` : ""), y = u(() => o.outlined ? "uikit-btn-outline" : "");
    b(() => {
      n.value = o.iconName ?? "";
    });
    const c = () => {
      i.value = !0, o.iconNameHovering && l(o.iconNameHovering);
    }, k = () => {
      i.value = !1, o.iconNameHovering && l(o.iconName);
    }, l = (e) => {
      n.value = e;
    };
    return (e, t) => (r(), B("button", {
      id: e.$attrs.id,
      "data-cy": e.$attrs["data-cy"],
      type: e.$attrs.type,
      class: $([
        {
          "uikit-btn": !e.isEmpty,
          "uikit-btn-empty": e.isEmpty,
          "active uikit-font-medium": e.keepActive,
          "uikit-flex uikit-items-center uikit-justify-center": e.iconName || e.isLoading
        },
        e.btnClass,
        p.value,
        y.value
      ]),
      style: g(e.$attrs.style),
      "data-active": e.keepActive,
      disabled: e.isLoading || e.disabled,
      "aria-labelledby": e.$attrs.id,
      onMouseover: t[0] || (t[0] = d((a) => {
        c(), e.$emit("mouseover", a);
      }, ["stop"])),
      onMouseout: t[1] || (t[1] = d((a) => {
        k(), e.$emit("mouseout", a);
      }, ["stop"])),
      onClick: t[2] || (t[2] = (a) => e.$emit("click", a))
    }, [
      e.iconName && !e.isLoading ? (r(), N(L, {
        key: e.$attrs.id ? e.$attrs.id : `btn-${e.iconName}`,
        "icon-name": n.value,
        "icon-class": e.iconClass,
        "alt-attribute": "button icon",
        "lazy-loading": e.lazyLoadIcon
      }, null, 8, ["icon-name", "icon-class", "lazy-loading"])) : z("", !0),
      e.isLoading ? m(e.$slots, "spinner", { key: 2 }, () => [
        C(M, {
          "stroke-color": e.outlined ? "#ACB4C3" : "#fff"
        }, null, 8, ["stroke-color"])
      ]) : m(e.$slots, "default", {
        key: 1,
        hover: i.value
      })
    ], 46, H));
  }
});
export {
  E as _
};
